import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42103c9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row mt-2 mt-lg-3 mb-1" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "row mb-2 mb-lg-3"
}
const _hoisted_7 = {
  key: 0,
  class: "loader d-flex flex-column justify-content-center align-items-center text-center mx-auto form-group col-md-12 col-lg-10 col-xxl-8"
}
const _hoisted_8 = {
  key: 0,
  class: "col-12 col-md-12"
}
const _hoisted_9 = { class: "d-lg-none d-block" }
const _hoisted_10 = { class: "mt-1 mb-3 login-text" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_13 = { class: "d-none d-lg-block mt-1 mb-3 login-text" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-right login-chev" }, null, -1))
const _hoisted_16 = { class: "col-12 col-lg-7" }
const _hoisted_17 = { class: "form-row" }
const _hoisted_18 = { class: "form-group col-md-6 col-xxl-5" }
const _hoisted_19 = { class: "form-group col-md-6 col-xxl-5" }
const _hoisted_20 = { class: "form-row" }
const _hoisted_21 = { class: "form-group col-md-12 col-xxl-10" }
const _hoisted_22 = { class: "form-row" }
const _hoisted_23 = { class: "form-group col-md-12 col-xxl-10" }
const _hoisted_24 = { class: "form-row" }
const _hoisted_25 = { class: "form-group col-md-12 col-xxl-10" }
const _hoisted_26 = { class: "form-row" }
const _hoisted_27 = { class: "form-group col-md-12 col-xxl-10 d-flex" }
const _hoisted_28 = {
  class: "ml-1 mb-0",
  for: "wantsService"
}
const _hoisted_29 = { class: "form-row" }
const _hoisted_30 = { class: "form-group col-md-12 col-xxl-10 d-flex" }
const _hoisted_31 = {
  class: "ml-1 mb-0",
  for: "wantsMoreProducts"
}
const _hoisted_32 = { class: "form-row" }
const _hoisted_33 = { class: "form-group col-md-12 col-xxl-10" }
const _hoisted_34 = { class: "product-message-note" }
const _hoisted_35 = { class: "form-row" }
const _hoisted_36 = { class: "form-group col-md-12 col-xxl-10 d-flex" }
const _hoisted_37 = {
  class: "ml-1 mb-0",
  for: "hasAutodeskCSN"
}
const _hoisted_38 = { class: "form-row" }
const _hoisted_39 = { class: "form-group col-md-12 col-xxl-10" }
const _hoisted_40 = { class: "form-row" }
const _hoisted_41 = { class: "form-group col-md-6 col-xxl-5 d-flex justify-content-center" }
const _hoisted_42 = { class: "form-group col-md-6 col-xxl-5" }
const _hoisted_43 = { class: "form-row" }
const _hoisted_44 = {
  key: 0,
  id: "`recaptcha-help`",
  class: "p-error"
}
const _hoisted_45 = { class: "col-12 col-lg-5 d-none d-lg-block" }
const _hoisted_46 = { class: "product-summary" }
const _hoisted_47 = { class: "d-flex justify-content-between flex-wrap-reverse mb-2 mb-sm-3" }
const _hoisted_48 = { class: "mr-2" }
const _hoisted_49 = ["alt", "src"]
const _hoisted_50 = { class: "d-flex flex-column flex-1" }
const _hoisted_51 = { class: "mb-0 text-muted lead" }
const _hoisted_52 = { class: "mb-0" }
const _hoisted_53 = { class: "d-flex justify-content-between flex-wrap-reverse mb-1 mb-sm-2" }
const _hoisted_54 = { class: "col-6 d-flex align-items-center" }
const _hoisted_55 = { class: "product-term" }
const _hoisted_56 = { class: "col-6 d-flex align-items-center" }
const _hoisted_57 = { class: "product-detail" }
const _hoisted_58 = {
  key: 0,
  class: "d-flex justify-content-between flex-wrap-reverse mb-1 mb-sm-2"
}
const _hoisted_59 = { class: "col-6 d-flex align-items-center" }
const _hoisted_60 = { class: "product-term" }
const _hoisted_61 = { class: "col-6 d-flex align-items-center" }
const _hoisted_62 = { class: "product-detail" }
const _hoisted_63 = {
  key: 1,
  class: "d-flex justify-content-between flex-wrap-reverse mb-1 mb-sm-2"
}
const _hoisted_64 = { class: "col-6 d-flex align-items-center" }
const _hoisted_65 = { class: "product-term" }
const _hoisted_66 = { class: "col-6 d-flex align-items-center" }
const _hoisted_67 = { class: "product-detail" }
const _hoisted_68 = {
  key: 2,
  class: "d-flex justify-content-between flex-wrap-reverse"
}
const _hoisted_69 = { class: "col-12" }
const _hoisted_70 = { class: "bottom-text" }
const _hoisted_71 = {
  key: 0,
  style: {'background-image': `url('/Static/images/stars-background.jpg')`},
  class: "wallet-card"
}
const _hoisted_72 = ["alt"]
const _hoisted_73 = { class: "wallet-text" }
const _hoisted_74 = {
  key: 1,
  class: "wallet-amount"
}
const _hoisted_75 = {
  key: 1,
  class: "row mb-2 mb-lg-3 thank-you-container"
}
const _hoisted_76 = { class: "thank-you-content" }
const _hoisted_77 = { class: "mb-3" }
const _hoisted_78 = { class: "mb-3" }
const _hoisted_79 = {
  alt: "Cadac Group",
  class: "thank-you-img mb-3"
}
const _hoisted_80 = {
  key: 0,
  class: "d-block d-lg-none sticky-bottom-panel py-2"
}
const _hoisted_81 = { class: "container" }
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "col-12" }
const _hoisted_84 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_85 = { class: "d-flex justify-content-between flex-wrap-reverse pr-sm-4 pr-3" }
const _hoisted_86 = { class: "mr-sm-2 mr-1" }
const _hoisted_87 = ["alt", "src"]
const _hoisted_88 = { class: "product-text-wrapper d-flex flex-column flex-1" }
const _hoisted_89 = { class: "mb-0 text-muted lead" }
const _hoisted_90 = { class: "mb-0 title" }
const _hoisted_91 = { class: "price-text-wrapper text-right" }
const _hoisted_92 = { class: "product-term" }
const _hoisted_93 = {
  key: 0,
  class: "product-term"
}
const _hoisted_94 = {
  key: 1,
  class: "price-text"
}
const _hoisted_95 = {
  key: 0,
  class: "price-text-wallet-amount"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuotationSteps = _resolveComponent("QuotationSteps")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputWithValidation = _resolveComponent("InputWithValidation")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (this.activeStep === 1)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.$t("quotation.page.title.step1")), 1))
            : _createCommentVNode("", true),
          (this.activeStep === 2)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.$t("quotation.page.title.step2")), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_QuotationSteps, {
            "active-step": this.activeStep
          }, null, 8, ["active-step"])
        ])
      ]),
      (this.activeStep === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.isSpinnerVisible('loading'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_ProgressSpinner, {
                    "animation-duration": "1.75s",
                    "stroke-width": "4"
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isSpinnerVisible('loading'))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!_ctx.layoutStore.isAuthenticated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("quotation.login.text")), 1),
                          _createElementVNode("a", {
                            class: "text-underline login-button",
                            href: _ctx.loginPageUrl
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("quotation.login.button.text")) + " ", 1),
                            _hoisted_12
                          ], 8, _hoisted_11)
                        ]),
                        _createElementVNode("p", _hoisted_13, [
                          _createTextVNode(_toDisplayString(_ctx.$t("quotation.login.text")) + " ", 1),
                          _createElementVNode("a", {
                            class: "text-underline",
                            href: _ctx.loginPageUrl
                          }, [
                            _createTextVNode("Log in "),
                            _hoisted_15
                          ], 8, _hoisted_14)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("section", _hoisted_16, [
                    _createElementVNode("form", {
                      class: "position-relative",
                      onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.formStateChanged && _ctx.formStateChanged(...args)))
                    }, [
                      (!_ctx.isSpinnerVisible('loading'))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_InputWithValidation, {
                                  "is-required": _ctx.validations['firstName'].required,
                                  label: _ctx.$t('common.forms.lblFirstName'),
                                  name: "firstName"
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_InputText, {
                                      modelValue: field.value.value,
                                      "onUpdate:modelValue": ($event: any) => ((field.value.value) = $event),
                                      class: _normalizeClass({ 'p-invalid': field.errors?.length }),
                                      feedback: false,
                                      name: field.name,
                                      "toggle-mask": "",
                                      placeholder: _ctx.$t('common.forms.lblFirstName'),
                                      onBlur: ($event: any) => (field.setTouched(true))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "name", "placeholder", "onBlur"])
                                  ]),
                                  _: 1
                                }, 8, ["is-required", "label"])
                              ]),
                              _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_InputWithValidation, {
                                  "is-required": _ctx.validations['lastName'].required,
                                  label: _ctx.$t('common.forms.lblLastName'),
                                  name: "lastName"
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_InputText, {
                                      modelValue: field.value.value,
                                      "onUpdate:modelValue": ($event: any) => ((field.value.value) = $event),
                                      class: _normalizeClass({ 'p-invalid': field.errors?.length }),
                                      feedback: false,
                                      name: field.name,
                                      "toggle-mask": "",
                                      placeholder: _ctx.$t('common.forms.lblLastName'),
                                      onBlur: ($event: any) => (field.setTouched(true))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "name", "placeholder", "onBlur"])
                                  ]),
                                  _: 1
                                }, 8, ["is-required", "label"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_InputWithValidation, {
                                  "is-required": _ctx.validations['email'].required,
                                  label: _ctx.$t('common.forms.lblEmail'),
                                  name: "email"
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_InputText, {
                                      modelValue: field.value.value,
                                      "onUpdate:modelValue": ($event: any) => ((field.value.value) = $event),
                                      class: _normalizeClass({ 'p-invalid': field.errors?.length }),
                                      feedback: false,
                                      name: field.name,
                                      "toggle-mask": "",
                                      placeholder: _ctx.$t('common.forms.lblEmail'),
                                      onBlur: ($event: any) => (field.setTouched(true))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "name", "placeholder", "onBlur"])
                                  ]),
                                  _: 1
                                }, 8, ["is-required", "label"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_InputWithValidation, {
                                  "is-required": _ctx.validations['phone'].required,
                                  label: _ctx.$t('common.forms.lblPhoneNumber'),
                                  name: "phone"
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_vue_tel_input, {
                                      modelValue: field.value.value,
                                      "onUpdate:modelValue": ($event: any) => ((field.value.value) = $event),
                                      class: _normalizeClass({ 'p-invalid': field.errors?.length }),
                                      "input-options": { placeholder: _ctx.$t('common.forms.lblPhoneNumber') },
                                      onChange: ($event: any) => (field.setTouched(true)),
                                      onValidate: _ctx.onPhoneInputValidate
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "input-options", "onChange", "onValidate"])
                                  ]),
                                  _: 1
                                }, 8, ["is-required", "label"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createVNode(_component_InputWithValidation, {
                                  "is-required": _ctx.validations['companyName'].required,
                                  label: _ctx.$t('common.forms.lblCompanyName'),
                                  name: "companyName"
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_InputText, {
                                      modelValue: field.value.value,
                                      "onUpdate:modelValue": ($event: any) => ((field.value.value) = $event),
                                      class: _normalizeClass(["w-100", { 'p-invalid': field.errors?.length }]),
                                      name: field.name,
                                      placeholder: _ctx.$t('common.forms.lblCompanyName'),
                                      onBlur: ($event: any) => (field.setTouched(true))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "name", "placeholder", "onBlur"])
                                  ]),
                                  _: 1
                                }, 8, ["is-required", "label"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_Checkbox, {
                                  modelValue: _ctx.form.values.wantsService,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.values.wantsService) = $event)),
                                  inputId: "wantsService",
                                  binary: true,
                                  name: "wantsService"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('quotation.field.wantsService')), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(_component_Checkbox, {
                                  modelValue: _ctx.form.values.wantsMoreProducts,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.values.wantsMoreProducts) = $event)),
                                  inputId: "wantsMoreProducts",
                                  binary: true,
                                  name: "wantsMoreProducts",
                                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkboxFieldProducts.setTouched(true)))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('quotation.field.wantsMoreProducts')), 1)
                              ])
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('quotation.field.productMessage.note')), 1),
                                _createVNode(_component_InputWithValidation, {
                                  "is-required": _ctx.validations['productMessage'].required,
                                  name: "productMessage"
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_Textarea, {
                                      modelValue: field.value.value,
                                      "onUpdate:modelValue": ($event: any) => ((field.value.value) = $event),
                                      class: _normalizeClass({ 'p-invalid': field.errors?.length, 'message-field': 'message-field' }),
                                      rows: "4",
                                      type: "text",
                                      name: field.name,
                                      placeholder: _ctx.$t('quotation.field.productMessage.placeholder'),
                                      onBlur: ($event: any) => (field.setTouched(true))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "name", "placeholder", "onBlur"])
                                  ]),
                                  _: 1
                                }, 8, ["is-required"])
                              ])
                            ], 512), [
                              [_vShow, _ctx.checkboxFieldProducts.checked]
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createVNode(_component_Checkbox, {
                                  modelValue: _ctx.form.values.hasCSN,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.values.hasCSN) = $event)),
                                  inputId: "hasAutodeskCSN",
                                  binary: true,
                                  name: "hasCSN",
                                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkboxFieldCSN.setTouched(true)))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('quotation.field.hasCSN')), 1)
                              ])
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, [
                                _createVNode(_component_InputWithValidation, {
                                  "is-required": _ctx.validations['message'].required,
                                  name: "message"
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_Textarea, {
                                      modelValue: field.value.value,
                                      "onUpdate:modelValue": ($event: any) => ((field.value.value) = $event),
                                      class: _normalizeClass({ 'p-invalid': field.errors?.length, 'message-field': 'message-field' }),
                                      rows: "4",
                                      type: "text",
                                      name: field.name,
                                      placeholder: _ctx.$t('quotation.field.message.placeholder'),
                                      onBlur: ($event: any) => (field.setTouched(true))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "name", "placeholder", "onBlur"])
                                  ]),
                                  _: 1
                                }, 8, ["is-required"])
                              ])
                            ], 512), [
                              [_vShow, _ctx.checkboxFieldCSN.checked]
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createVNode(_component_Button, {
                                  class: "w-100 p-button-brand-secondary p-button-lg",
                                  label: _ctx.$t('common.cancel'),
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goBack()))
                                }, null, 8, ["label"])
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _createVNode(_component_Button, {
                                  class: "w-100 p-button-success p-button-lg",
                                  label: _ctx.$t('quotation.field.submit'),
                                  loading: _ctx.isLoading,
                                  disabled: !_ctx.isValid || _ctx.isLoading,
                                  onClick: _ctx.onSubmit
                                }, null, 8, ["label", "loading", "disabled", "onClick"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              (_ctx.submitted && _ctx.recaptchaValid === false)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString(_ctx.$t("validations.recaptcha")), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 32)
                  ]),
                  _createElementVNode("section", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("img", {
                            class: "product-summary-icon",
                            alt: _ctx.vm?.firstProductSelection?.product?.icon?.altTag,
                            src: _ctx.vm?.firstProductSelection?.product?.icon?.url
                          }, null, 8, _hoisted_49)
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.vm.firstProductSelection.product.brand), 1),
                          _createElementVNode("h4", _hoisted_52, _toDisplayString(_ctx.vm.firstProductSelection.product.name), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('quotation.product.amount.label')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.vm.firstProductSelection.amount), 1)
                        ])
                      ]),
                      (_ctx.vm.firstProductSelection.product.durationInMonths)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('quotation.product.duration.label')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t("quotation.product.duration.months", [_ctx.vm.firstProductSelection.product.durationInMonths])), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.vm.firstProductSelection?.product?.prices?.valueBased)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t('quotation.product.price.label')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.formatCurrency(_ctx.vm.firstProductSelection.totalPrice.basePrice)), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.vm.firstProductSelection?.product?.prices?.valueBased)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.$t('quotation.product.price.subText')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.vm.autodeskLoyaltyCashbackBlock?.isVisible && (parseInt(_ctx.vm.firstProductSelection?.totalWalletAmount) !== 0 || _ctx.vm.firstProductSelection?.product?.prices?.valueBased))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          (_ctx.vm.autodeskLoyaltyCashbackBlock?.icon)
                            ? _withDirectives((_openBlock(), _createElementBlock("img", {
                                key: 0,
                                alt: _ctx.vm.autodeskLoyaltyCashbackBlock?.icon?.alt,
                                class: "wallet-icon"
                              }, null, 8, _hoisted_72)), [
                                [_directive_lazy, _ctx.vm.autodeskLoyaltyCashbackBlock?.icon?.url]
                              ])
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.vm.autodeskLoyaltyCashbackBlock?.text), 1),
                          (!_ctx.vm.firstProductSelection?.product?.prices?.valueBased)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(_ctx.formatCurrency(_ctx.vm.firstProductSelection?.totalWalletAmount)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (this.activeStep === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("h1", _hoisted_77, _toDisplayString(_ctx.$t('quotation.thankYou.title')), 1),
              _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.$t('quotation.thankYou.text')), 1),
              _withDirectives(_createElementVNode("img", _hoisted_79, null, 512), [
                [_directive_lazy, '/Static/images/support.png']
              ]),
              _createVNode(_component_Button, {
                class: "w-100 p-button-primary p-button-raised p-button-lg",
                label: _ctx.$t('quotation.thankYou.backButton'),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goBack()))
              }, null, 8, ["label"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isSpinnerVisible('loading') && this.activeStep === 1)
      ? (_openBlock(), _createElementBlock("section", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("img", {
                        class: "product-summary-icon",
                        alt: _ctx.vm?.firstProductSelection?.product?.icon?.altTag,
                        src: _ctx.vm?.firstProductSelection?.product?.icon?.url
                      }, null, 8, _hoisted_87)
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("p", _hoisted_89, _toDisplayString(_ctx.vm.firstProductSelection.product.brand), 1),
                      _createElementVNode("h4", _hoisted_90, _toDisplayString(_ctx.vm.firstProductSelection.product.name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.$t('quotation.product.amount.label')) + ": " + _toDisplayString(_ctx.vm.firstProductSelection.amount), 1),
                    (_ctx.vm.firstProductSelection.product.durationInMonths)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_ctx.$t('quotation.product.duration.label')) + ": " + _toDisplayString(_ctx.$t("quotation.product.duration.months", [_ctx.vm.firstProductSelection.product.durationInMonths])), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.vm.firstProductSelection?.product?.prices?.valueBased)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(_ctx.formatCurrency(_ctx.vm.firstProductSelection.totalPrice.basePrice)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (!_ctx.vm.firstProductSelection?.product?.prices?.valueBased)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(_ctx.$t('quotation.product.wallet.label')) + " " + _toDisplayString(_ctx.formatCurrency(_ctx.vm.firstProductSelection.totalWalletAmount)), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}